import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

import {lazy} from 'react'

import Layout from "./component/Layout";
// import Home from "./component/Home";
// import StepsToApplyEmiratesVisa from "./component/StepsToApplyEmiratesVisa";
// import EmiratesVisaTypes from "./component/EmiratesVisaTypes";
// import TrackVisaApplication from "./component/TrackVisaApplication";
// import Apply from "./component/Apply";
// import TermsAndConditions from "./component/TermsAndConditions";
// import PrivacyPolicy from "./component/PrivacyPolicy";
// import EmiratesVisaFaqs from "./component/EmiratesVisaFaqs";
// import EmiratesVisaBlog from "./component/EmiratesVisaBlog";
// import AboutUs from "./component/AboutUs";
// import Checkout from "./component/Checkout";
// import CustomerReview from "./component/CustomerReview";
// import BlogDetail from "./component/BlogDetail";
// import EditApplicant from './component/EditApplicant';
// import EmiratesVisa from './component/EmiratesVisa';
// import ApplyVisa from './component/ApplyVisa';
// import TawkMessengerReact from '@tawk.to/tawk-messenger-react';



// import Contact from "./component/Contact";
// import NoPage from "./component/NoPage";
// import PaymentSuccess from "./component/PaymentSuccess";
// import PaymentFailure from "./component/PaymentFailure";

const Home = lazy(() => import("./component/Home"));
const StepsToApplyEmiratesVisa = lazy(() => import("./component/StepsToApplyEmiratesVisa"));
const EmiratesVisaTypes = lazy(() => import("./component/EmiratesVisaTypes"));
const TrackVisaApplication = lazy(() => import("./component/TrackVisaApplication"));
const Apply = lazy(() => import("./component/Apply"));
const TermsAndConditions = lazy(() => import("./component/TermsAndConditions"));
const PrivacyPolicy = lazy(() => import("./component/PrivacyPolicy"));
const EmiratesVisaFaqs = lazy(() => import("./component/EmiratesVisaFaqs"));
const EmiratesVisaBlog = lazy(() => import("./component/EmiratesVisaBlog"));
const AboutUs = lazy(() => import("./component/AboutUs"));
const Checkout = lazy(() => import("./component/Checkout"));
const CustomerReview = lazy(() => import("./component/CustomerReview"));
const BlogDetail = lazy(() => import("./component/BlogDetail"));
const EditApplicant = lazy(() => import('./component/EditApplicant'));
const EmiratesVisa = lazy(() => import('./component/EmiratesVisa'));
const ApplyVisa = lazy(() => import('./component/ApplyVisa'));
const TawkMessengerReact = lazy(() => import('@tawk.to/tawk-messenger-react'));
const Contact = lazy(() => import("./component/Contact"));
const NoPage = lazy(() => import("./component/NoPage"));
const PaymentSuccess = lazy(() => import("./component/PaymentSuccess"));
const PaymentFailure = lazy(() => import("./component/PaymentFailure"));


export default function App() {
  return (
    <HelmetProvider>
    <>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="apply-etihad-uae-visa" element={<StepsToApplyEmiratesVisa />} />
          <Route path="uae-visa-types" element={<EmiratesVisaTypes />} />
          <Route path="etihad-uae-visa-status/:id" element={<TrackVisaApplication />} />
          <Route path="etihad-uae-visa-status" element={<TrackVisaApplication />} />
          <Route path="etihad-uae-visa-application-form" element={<ApplyVisa />} />
          <Route path="terms-conditions" element={<TermsAndConditions />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="uae-visa-faqs" element={<EmiratesVisaFaqs />} />
          <Route path="articles" element={<EmiratesVisaBlog />} />
          <Route path="about-us" element={<AboutUs />} />
          <Route path="contact" element={<Contact />} />
          <Route path="apply/:id" element={<Apply />} />
          <Route path="checkout/:id" element={<Checkout />} />
          <Route path="reviews" element={<CustomerReview />} />
          <Route path="articles/:id" element={<BlogDetail />} />
          <Route path="applicant/edit/:id" element={<EditApplicant />} />
          <Route path="apply-now-visa/:visa" element={<ApplyVisa />} />
          <Route path=":citizen/:travelling/etihad-uae-visa" element={<EmiratesVisa />} />
          <Route path=":visa/:citizen/:travelling/etihad-uae-visa-application-form" element={<ApplyVisa />} />
          <Route path="payment-success/:id" element={<PaymentSuccess />} />
          <Route path="payment-failure/:id" element={<PaymentFailure />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
      <TawkMessengerReact
          propertyId="68f59a397d479d194d3b8b9e"
          widgetId="1j7vm4sla" />
    </>
    </HelmetProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);